<template>
  <v-navigation-drawer v-model="isVisible" app temporary right>
    <v-list nav dense>
      <v-list-item-group
        v-model="group"
        v-if="getIsMaintenanceModeOn && !isAuthenticated"
      >
        <v-list-item @click="reloadPage">
          <v-list-item-icon class="mr-1">
            <v-icon small>mdi-refresh</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="proxima-medium--font"
            >Reload this Page</v-list-item-title
          >
        </v-list-item>
        <v-list-item v-if="!canMerchant" :to="{ name: MerchantLoginRoute }">
          <v-list-item-icon class="mr-1">
            <v-icon small>mdi-login</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="proxima-medium--font"
            >Owner Login</v-list-item-title
          >
        </v-list-item>
      </v-list-item-group>
      <v-list-item-group v-model="group" v-else>
        <v-list-item
          v-if="isAuthenticated && isAuthUserEmailVerified"
          exact
          :to="{ name: NewOrderRoute }"
          class="order-now-btn"
          color="deep-orange"
        >
          <v-list-item-title
            class="proxima-medium--font deep-orange--text font-weight-bold"
            >Order Now</v-list-item-title
          >
        </v-list-item>
        <v-list-item to="/">
          <v-list-item-title class="proxima-medium--font"
            >Home</v-list-item-title
          >
        </v-list-item>
        <v-list-item to="/menu" v-if="!isAuthenticated">
          <v-list-item-title class="proxima-medium--font"
            >View the Menu</v-list-item-title
          >
        </v-list-item>

        <v-list-item v-if="getBooleanToggle('Enable About Page')" to="/about">
          <v-list-item-title class="proxima-medium--font"
            >About Our Shop</v-list-item-title
          >
        </v-list-item>
        <v-list-item :to="{ name: CustomerLoginRoute }" v-if="!isAuthenticated">
          <v-list-item-title class="proxima-medium--font"
            >Login / Signup</v-list-item-title
          >
        </v-list-item>

        <template v-if="isAuthenticated && !canMerchant">
          <v-divider />
          <v-subheader>{{
            !!getCustomerName ? getCustomerName : 'Signed In'
          }}</v-subheader>

          <template v-if="isAuthUserEmailVerified">
            <v-list-item exact :to="{ name: CustomerHomeRoute }">
              <v-list-item-title class="proxima-medium--font"
                >Order History</v-list-item-title
              >
            </v-list-item>
            <v-list-item exact :to="{ name: CustomerAccountUpdateRoute }">
              <v-list-item-title class="proxima-medium--font"
                >Account Details</v-list-item-title
              >
            </v-list-item>
          </template>
          <v-list-item v-else :to="{ name: CustomerVerifyEmailRoute }">
            <v-list-item-title class="proxima-medium--font"
              >Verify Email</v-list-item-title
            >
          </v-list-item>
          <v-list-item @click="customerLogoutHandler">
            <v-list-item-title class="proxima-medium--font"
              >Log Out</v-list-item-title
            >
          </v-list-item>
          <v-divider />
        </template>

        <v-list-item to="/help">
          <v-list-item-icon class="mr-1">
            <v-icon small>mdi-help-circle</v-icon>
          </v-list-item-icon>

          <v-list-item-title class="proxima-medium--font"
            >Help</v-list-item-title
          >
        </v-list-item>

        <v-list-item
          v-if="getIsBakeSale"
          href="https://bakersagainstracism.com/"
          target="_blank"
        >
          <v-list-item-icon class="mr-1">🍩</v-list-item-icon>
          <v-list-item-title class="proxima-medium--font"
            >About B.A.R.</v-list-item-title
          >
        </v-list-item>

        <v-list-item v-if="!isAuthenticated" :to="{ name: MerchantLoginRoute }">
          <v-list-item-icon class="mr-1">
            <v-icon small>mdi-login</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="proxima-medium--font"
            >Owner Login</v-list-item-title
          >
        </v-list-item>
        <template v-else-if="isAuthenticated && canMerchant">
          <v-divider></v-divider>
          <v-subheader>Admin</v-subheader>
          <v-list-item
            :to="{ name: MerhcantHomeRoute }"
            color="deep-orange"
            exact
          >
            <v-list-item-icon class="mr-1">
              <v-icon small>mdi-tune</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="proxima-medium--font"
              >Owner Dashboard</v-list-item-title
            >
          </v-list-item>
          <v-list-item :to="{ name: MerchantSupportRoute }" color="deep-orange">
            <v-list-item-icon class="mr-1">
              <v-icon small>mdi-lifebuoy</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="proxima-medium--font"
              >Minimart FAQ</v-list-item-title
            >
          </v-list-item>
          <v-list-item @click="merchantLogoutHandler" color="deep-orange">
            <v-list-item-icon class="mr-1">
              <v-icon small>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="proxima-medium--font"
              >Owner Logout</v-list-item-title
            >
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
    <template #append>
      <div class="pa-4 pb-6">
        <h3 class="feedback-prompt text-center mb-3 font-italic"
          >How can Minimart<br />
          be improved?</h3
        >
        <v-btn to="/feedback" class="mt-2" text small outlined block
          >Send us Feedback</v-btn
        >
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  CustomerRoutes,
  MerchantRoutes,
  GuestRoutes,
} from '@/constants/RouteNames'
export default {
  name: 'NavDrawer',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  computed: {
    ...mapGetters('customer', ['getCustomerName']),
    ...mapGetters('shop', [
      'getBooleanToggle',
      'getIsBakeSale',
      'getIsMaintenanceModeOn',
    ]),
    ...mapGetters('auth', [
      'isAuthenticated',
      'canMerchant',
      'isAuthUserEmailVerified',
    ]),

    isVisible: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('toggle', val)
      },
    },
  },
  data() {
    return {
      MerchantLoginRoute: MerchantRoutes.LOGIN,
      MerhcantHomeRoute: MerchantRoutes.Manage.HOME,
      MerchantSupportRoute: MerchantRoutes.Manage.SUPPORT,
      NewOrderRoute: GuestRoutes.NEW_ORDER,
      CustomerLoginRoute: CustomerRoutes.LOGIN,
      CustomerHomeRoute: CustomerRoutes.ORDERS_INDEX,
      CustomerAccountUpdateRoute: CustomerRoutes.ACCOUNT_UPDATE,
      CustomerVerifyEmailRoute: CustomerRoutes.VERIFY_EMAIL,
      group: null,
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    async customerLogoutHandler() {
      await this.logout()

      this.$router.push({
        name: this.CustomerLoginRoute,
        query: { loggedOut: true },
      })
    },
    async merchantLogoutHandler() {
      await this.logout()
      this.$router.push({
        name: this.MerchantLoginRoute,
        query: { loggedOut: true },
      })
    },
    reloadPage() {
      let href = window.location.href
      window.location.href = href
    }, // reloadPage
  },
}
</script>

<style lang="scss" scoped>
.v-list-item {
  .v-list-item__title {
    text-transform: uppercase;
    letter-spacing: 0.0892857143em;
  }
  .v-list-item__icon .v-icon {
    margin-top: -0.1875em;
  }
}
.feedback-prompt {
  line-height: 1.2;
}
.order-now-btn {
  border: 2px solid #ff5722;
  &.v-item--active {
    border: 2px solid transparent;
  }
}
</style>
